import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Tree } from "primereact/tree";
import Langs from "../../../../app/lang/langs";

const ORANGE = "#FF9015";

/**
 * MobilePublicFormTab - Mobile version of PublicFormTab.
 * Uses PrimeReact Tree with selectionMode="checkbox" (same as desktop)
 * wrapped in mobile-friendly MUI containers.
 */
export default function MobilePublicFormTab({
    isMobile,
    mode,
    nodes,
    selectedKeys,
    onSelectionChange,
    nodeTemplatePublic,
    onPrevious,
    onNext,
}) {
    const showPrevious = onPrevious && mode !== "edit";

    return (
        <Box
            sx={{
                mt: 0,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
            }}
        >
            {/* Header label */}
            <Box
                sx={{
                    px: 2,
                    pt: 2,
                    pb: 1,
                    backgroundColor: "var(--surface-card, #fff)",
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                    flexShrink: 0,
                }}
            >
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 700,
                        fontSize: "1rem",
                        color: "#333",
                    }}
                >
                    <Langs str="ADD_PUBLIC_APTITUDES" />
                </Typography>
            </Box>

            {/* PrimeReact Tree with checkbox selection */}
            <Box
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    WebkitOverflowScrolling: "touch",
                    pb: 10,
                }}
            >
                <Box sx={{ height: "calc(100vh - 280px)" }}>
                    <Tree
                        value={nodes}
                        selectionMode="checkbox"
                        selectionKeys={selectedKeys}
                        filter={true}
                        nodeTemplate={nodeTemplatePublic}
                        filterPlaceholder="Search..."
                        onSelectionChange={(e) => onSelectionChange(e.value)}
                        className="w-full md:w-30rem custom-tree border-0"
                    />
                </Box>
            </Box>

            {/* Sticky bottom navigation */}
            <Box
                sx={{
                    position: "sticky",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: "flex",
                    gap: 1.5,
                    px: 2.5,
                    py: 2,
                    pb: "calc(env(safe-area-inset-bottom, 0px) + 24px)",
                    background: "linear-gradient(to top, rgba(255,255,255,0.92) 50%, rgba(255,255,255,0.78) 100%)",
                    backdropFilter: "blur(18px) saturate(1.6)",
                    WebkitBackdropFilter: "blur(18px) saturate(1.6)",
                    borderTop: "1px solid rgba(255, 144, 21, 0.15)",
                    boxShadow: "0 -4px 24px rgba(255, 144, 21, 0.06), 0 -1px 6px rgba(0, 0, 0, 0.04)",
                    zIndex: 10,
                }}
            >
                {showPrevious && (
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={onPrevious}
                        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: "16px !important" }} />}
                        sx={{
                            borderRadius: "14px",
                            textTransform: "none",
                            minHeight: 50,
                            fontWeight: 600,
                            fontSize: "0.95rem",
                            letterSpacing: "-0.01em",
                            border: "1.5px solid rgba(0, 0, 0, 0.12)",
                            color: "#4b5263",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                            transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                borderColor: "rgba(255, 144, 21, 0.35)",
                                backgroundColor: "rgba(255, 144, 21, 0.06)",
                                color: "#FF9015",
                            },
                            "&:active": { transform: "scale(0.98)" },
                        }}
                    >
                        <Langs str="Previous" />
                    </Button>
                )}
                <Button
                    fullWidth
                    variant="contained"
                    onClick={onNext}
                    sx={{
                        borderRadius: "14px",
                        textTransform: "none",
                        minHeight: 50,
                        fontWeight: 700,
                        fontSize: "0.95rem",
                        letterSpacing: "-0.01em",
                        background: "linear-gradient(135deg, #FF9015 0%, #FFA940 100%)",
                        backgroundColor: "#FF9015",
                        color: "#fff",
                        border: "none",
                        boxShadow: "0 4px 16px rgba(255, 144, 21, 0.40), 0 8px 32px rgba(255, 144, 21, 0.20), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                        transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                            background: "linear-gradient(135deg, #FF9015 0%, #FFB74D 100%)",
                            backgroundColor: "#FF9015",
                            boxShadow: "0 6px 24px rgba(255, 144, 21, 0.50), 0 12px 40px rgba(255, 144, 21, 0.25)",
                            transform: "translateY(-2px)",
                        },
                        "&:active": {
                            transform: "scale(0.98)",
                            boxShadow: "0 2px 10px rgba(255, 144, 21, 0.35)",
                        },
                    }}
                >
                    {mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />}
                </Button>
            </Box>
        </Box>
    );
}
